module.exports = __webpack_public_path__ + "img/装饰金币_上_外侧@2x.1f244871.png";